module.exports = __webpack_public_path__ + "static/media/hero-5.e9a0c915.jpg";